import { Grid, Typography, ButtonBase } from "@mui/material";
import { Helmet } from "react-helmet";
import logo from "../Recursos/logo_footer.svg";
import InstagramIcon from '@mui/icons-material/Instagram';
import { useLocation, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase/firebase";

const diasConfig = [
    { dia: "Lunes",      key: "horario_lunes" },
    { dia: "Martes",     key: "horario_martes" },
    { dia: "Miércoles",  key: "horario_miercoles" },
    { dia: "Jueves",     key: "horario_jueves" },
    { dia: "Viernes",    key: "horario_viernes" },
    { dia: "Sábado",     key: "horario_sabado" },
    { dia: "Domingo",    key: "horario_domingo" },
];

// Valores por defecto si Firestore aún no tiene datos
const horariosDefault = {
    horario_lunes:     "03:00 pm - 11:00 pm",
    horario_martes:    "03:00 pm - 11:00 pm",
    horario_miercoles: "03:00 pm - 11:00 pm",
    horario_jueves:    "03:00 pm - 11:00 pm",
    horario_viernes:   "03:00 pm - 11:00 pm",
    horario_sabado:    "03:00 pm - 11:00 pm",
    horario_domingo:   "",  // cerrado por defecto
};

const Footer = () => {
    const location = useLocation();
    const [horarios, setHorarios] = useState(horariosDefault);

    useEffect(() => {
        const cargar = async () => {
            try {
                const snap = await getDoc(doc(db, "configuracion", "textos"));
                if (snap.exists()) {
                    const data = snap.data();
                    setHorarios(prev => ({ ...prev, ...data }));
                }
            } catch (e) {
                console.error("Error cargando horarios:", e);
            }
        };
        cargar();
    }, []);

    // Solo muestra los días que tienen hora definida (no vacíos)
    const diasVisibles = diasConfig.filter(({ key }) => horarios[key]?.trim());

    return (
        <footer>
            <Helmet>
                <meta name="description"
                      content="Toppings en Colón Putumayo: comidas rápidas, helados y bebidas. Conoce horarios, dirección y contáctanos fácilmente."/>
                <meta name="keywords"
                      content="Toppings Colon Putumayo, comidas rápidas, helados, bebidas, horarios, contacto, colon putumayo, restaurante colon, colon"/>
            </Helmet>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{ xs: 12, sm: 12, md: 12 }}

                sx={{
                    pt: location.pathname === "/pagina-misteriosa" ? 0 : 5,

                }}
            >
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    size={{ xs: 12, sm: 12, md: 12 }}
                    sx={{
                        pt: 5,
                        pb: 5,
                        boxShadow: "0 -8px 15px -5px rgba(0,0,0,0.3)",
                        position: "relative",
                    }}

                >
                    <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        size={{ xs: 12, sm: 12, md: 10 }}
                        sx={{ maxWidth: '1800px', px: 3 }}
                    >
                        {/* LOGO */}
                        <Grid container justifyContent="center" alignItems="center" size={{xs: 12, sm: 12, md: 12}}>
                            <a href="/" title="Inicio Toppings">
                                <img src={logo} alt="Toppings comidas, helados y bebidas" style={{ width: 100, height: 100 }} />
                            </a>
                        </Grid>

                        {/* Horarios */}
                        <Grid container justifyContent="center" size={{ xs: 12 }} sx={{ pt: 3 }}>
                            <Typography component="h2" variant="h6" sx={{ fontWeight: "bold", pb: 1 }}>
                                Horarios de Apertura y Cierre
                            </Typography>

                            <Grid container justifyContent={'center'} alignItems={'center'} size={{ xs: 12 }}>
                                <Grid container size={{ xs: 12, sm: 8, md: 6 }} justifyContent="center" component="dl">
                                    {diasVisibles.length > 0 ? (
                                        diasVisibles.map(({ dia, key }) => (
                                            <Grid key={key} container justifyContent="space-between"
                                                  size={{ xs: 12 }} sx={{ py: 0.5 }}>
                                                <Typography component="dt" sx={{ color: "text.primary" }}>
                                                    {dia}
                                                </Typography>
                                                <Typography component="dd" sx={{ color: "text.secondary", m: 0 }}>
                                                    {horarios[key]}
                                                </Typography>
                                            </Grid>
                                        ))
                                    ) : (
                                        <Typography sx={{ color: "text.secondary", py: 1 }}>
                                            Temporalmente cerrado
                                        </Typography>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid container justifyContent="center" size={{xs: 12, sm: 12, md: 12}} sx={{ pt: 3 }} component="nav" aria-label="Redes sociales">
                            <ul style={{ display: "flex", gap: "2rem", listStyle: "none", padding: 0, margin: 0 }}>
                                <li>
                                    <ButtonBase
                                        component="a"
                                        href="https://www.instagram.com/Toppings.col"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        aria-label="Instagram Toppings"
                                    >
                                        <InstagramIcon sx={{ fontSize: 48, color: 'black' }} />
                                    </ButtonBase>
                                </li>
                                {/*<li>*/}
                                {/*    <ButtonBase*/}
                                {/*        component="a"*/}
                                {/*        href="https://youtube.com/@arq.marthaalvarez"*/}
                                {/*        target="_blank"*/}
                                {/*        rel="noopener noreferrer"*/}
                                {/*        aria-label="Facebook Toppings"*/}
                                {/*    >*/}
                                {/*        <FacebookRoundedIcon sx={{ fontSize: 48, color: 'black' }} />*/}
                                {/*    </ButtonBase>*/}
                                {/*</li>*/}
                            </ul>
                        </Grid>

                        <Grid
                            container
                            justifyContent="center"
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{ pt: 5 }}
                            component="address"
                            itemScope
                            itemType="https://schema.org/LocalBusiness"
                        >
                            <Typography
                                sx={{ textAlign: "center", fontWeight: 500, fontSize:16, fontStyle: "normal" }}
                                itemProp="address"
                                itemScope
                                itemType="https://schema.org/PostalAddress"
                            >
                                <span itemProp="streetAddress">Calle 3 Cra 9 Barrio Centro</span><br />
                                <span itemProp="addressLocality">Colón</span>, <span itemProp="addressRegion">Putumayo</span>
                            </Typography>
                        </Grid>
                        <Grid container justifyContent="center" size={{xs: 12, sm: 12, md: 12}} sx={{ pt: 1 }}>
                            <ButtonBase component="a" href="tel:+573137700223" title="Llamar a Toppings" itemProp="telephone">
                                <Typography sx={{ textAlign: "center", fontWeight: 500, fontSize:16 }}>
                                    313 770 0223
                                </Typography>
                            </ButtonBase>
                        </Grid>
                        <Grid container justifyContent="center" size={{xs: 12, sm: 12, md: 12}} sx={{ pt: 1 }}>
                            <ButtonBase component="a" href="/login" title="Llamar a Toppings" itemProp="telephone">
                                <Typography sx={{ textAlign: "center", fontWeight: 500, fontSize:16 }}>
                                    Admin
                                </Typography>
                            </ButtonBase>
                        </Grid>

                        <Grid container justifyContent={'center'} alignItems={'center'} size={{ xs: 12, sm: 12, md: 12 }} sx={{ pt: 5 }}>
                            <Grid container justifyContent={'center'} alignItems={'center'} size={{ xs: 12, sm: 4, md: 4 }}>
                                <ButtonBase component={Link} to="/politica-de-privacidad" title="Política de Privacidad">
                                    <Typography sx={{ fontFamily: 'Poppins', fontSize: 16, fontWeight: 400}}>
                                        Política de Privacidad
                                    </Typography>
                                </ButtonBase>
                            </Grid>
                            <Grid container justifyContent={'center'} alignItems={'center'} size={{ xs: 12, sm: 4, md: 4 }}>
                                <ButtonBase component={Link} to="/terminos-y-condiciones" title="Términos y Condiciones">
                                    <Typography sx={{ fontFamily: 'Poppins', fontSize: 16, fontWeight: 400 }}>
                                        Términos y Condiciones
                                    </Typography>
                                </ButtonBase>
                            </Grid>
                            <Grid container justifyContent={'center'} alignItems={'center'} size={{ xs: 12, sm: 4, md: 4 }}>
                                <ButtonBase component={Link} to="/politica-de-cookies" title="Política de Cookies">
                                    <Typography sx={{ fontFamily: 'Poppins', fontSize: 16, fontWeight: 400}}>
                                        Política de Cookies
                                    </Typography>
                                </ButtonBase>
                            </Grid>
                        </Grid>
                        {/* Derechos reservados */}
                        <Grid container justifyContent="center" alignItems="center" size={{ xs: 12 }} sx={{ pt: 5 }}>
                            <Typography sx={{ color: 'black', textAlign: "center", fontSize:12 }}>
                                Copyright © Todos los derechos reservados. By
                            </Typography>
                            <Grid
                                container
                                justifyContent={'center'}
                                alignItems={'center'}
                                size={{xs: 12, sm: 12, md: 12}}>
                                <Typography sx={{ color: 'black', textAlign: "center", fontSize:12 }}>
                                    digitalnexu.com
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </footer>
    )
}
export default Footer;